// extracted by mini-css-extract-plugin
module.exports = {"root":"Message_root__15JZM","avatar":"Message_avatar__1LFnd","fullName":"Message_fullName__2yC0y","date":"Message_date__3hAbv","messageText":"Message_messageText__YPAX_"};